import { ComponentProps } from 'react';
import ImageWithFallback from '../ImageWithFallback';
import {
  MAP_USERNAME,
  MAP_STYLE_ID,
  MAP_ZOOM,
  MAP_BEARING,
  MAP_PITCH,
  MAP_WIDTH,
  MAP_HEIGHT,
} from '../../../core/constants';
import Link from '../Link/Link';

type Props = {
  longitude: string;
  latitude: string;
  width?: number;
  height?: number;
  zoom?: number;
  url?: ComponentProps<typeof Link>['href'];
};

const MapboxStatic = ({
  longitude,
  latitude,
  width = MAP_WIDTH,
  height = MAP_HEIGHT,
  zoom = MAP_ZOOM,
  url,
}: Props) => {
  const accessToken = process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN;
  const pin = `pin-s+c43000(${longitude},${latitude})`;
  const mapImageUrl = `https://api.mapbox.com/styles/v1/${MAP_USERNAME}/${MAP_STYLE_ID}/static/${pin}/${longitude},${latitude},${zoom},${MAP_BEARING},${MAP_PITCH}/${width}x${height}@2x?access_token=${accessToken}`;

  return (
    <ImageWithFallback
      alt={`map of hotel at ${longitude}, ${latitude}`}
      src={mapImageUrl}
      objectFit="cover"
      layout="responsive"
      width={width}
      height={height}
      sizes={`(max-width: 768px) 100vw, ${width}px`}
      loading="lazy"
      fallbackSrc="/fallback-img-790x394.png"
      className="rounded-xl"
      url={url}
    />
  );
};

export default MapboxStatic;
